<!-- 借據管理_擔保品管理 -->
<template>
    <div v-if="$route.meta.subListKeepAlive">
        <workbench
            api="coopLoanIouCollateral"
            :query="query"
            :columns="columns"
            :toolbar="toolbar"
            @editData="editData"
            @addData="editData"
        >
        </workbench>
    </div>
    <router-view v-else></router-view>
</template>
<script>
import Workbench from "@/components/Workbench";

export default {
    name: "after_loan_collateral",
    components: { Workbench },
    data() {
        return {
            query: {
                coopLoanIouId: this.$route.params.id
            },
            toolbar: {},
            columns: [
                {
                    prop: "name",
                    label: "名稱"
                },
                {
                    prop: "subjectMatter",
                    label: "標的物"
                },
                {
                    prop: "setOrder",
                    label: "設定順位"
                },
                {
                    prop: "ownerName",
                    label: "所有權人"
                },
                {
                    prop: "basicInfo",
                    label: "基本資料（地號、建號、車號）"
                },
                {
                    prop: "valuationAmount",
                    label: "鑑價金額",
                    addcomma: true
                },
                {
                    prop: "isValuation",
                    label: "鑑價審查"
                },
                {
                    prop: "rightValue",
                    label: "權利價值",
                    addcomma: true
                },
                {
                    prop: "updateTime",
                    label: "最後修改"
                },
                {
                    prop: "updateUserName",
                    label: "最後修改人員"
                }
            ]
        };
    },
    methods: {
        /**
         * 進入擔保品編輯頁
         * @param {Number|String} id - 擔保品 id，新增時為 "new"
         */
        editData(id) {
            this.$router.push({
                name: "after_loan_collateral_edit",
                params: { subId: id }
            });
        }
    }
};
</script>
